export const environment = {
  production: true,
  api: '/api',
  chatApi: '/api',
  eventHost: ''
};
